import { render, staticRenderFns } from "./LvlBookInfos.vue?vue&type=template&id=361ab058&scoped=true&"
import script from "./LvlBookInfos.vue?vue&type=script&lang=js&"
export * from "./LvlBookInfos.vue?vue&type=script&lang=js&"
import style0 from "./LvlBookInfos.vue?vue&type=style&index=0&id=361ab058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361ab058",
  null
  
)

export default component.exports